import { get } from "lodash";
import moment from "moment";
import React from "react";
import * as Yup from 'yup';
import { printAction } from "../../../actions";
import { PRINT } from "../../../consts/methods.consts";
import { DefaultCell, DefaultCellV2 } from "./components/cells";

const StudentEnrolAndAttSummaryConfig = {
    searchApi: "xceed.api.report.programmed_module.student_enrolment_and_attendance_summary_report",
    alert:
        "Reminder: Specify a date range to receive reports.",
    excelFileName: "student-enrolment-and-summary-report",
    title: "Student Enrolment & Attendance Summary Report",
    extraActionsAsMenu: true,
    sections: [
        {
            selectionTitle: "Date Range",
            grid: { base: 1, md: 2, lg: 4, xl: 4 },
            filters: [
                {
                    is_required: true,
                    label: "From",
                    type: "date",
                    key: "from",
                    validationSchema: Yup.string().required('From is required'),
                },
                {
                    is_required: true,
                    label: "To",
                    type: "date",
                    key: "to",
                    validationSchema: Yup.string().required('To is required'),
                },
            ],
        }
    ],

    tableConfig: {
        column: [
            {
                header: "PA Name",
                accessor: "pa",
                width: 300,
            },
            {
                header: "Pending Module Enrolment",
                accessor: "pending_enrolment",
                customRenderer: (value: any, item: any) => {
                    if (value == 0) return value
                    const fromDate = get(item, "from_date", "");
                    const toDate = get(item, "to_date", "");
                    const pa_id = get(item, "pa_id", "");
                    const queryPrams = `from=${moment(fromDate).format("YYYY-MM-DD")}&to=${moment(toDate).format("YYYY-MM-DD")}&pa_id=${pa_id}&type=module_enrolment`;
                    const link = `/app/report/custom/student-enrolment-&-attendance-detailed-report?${queryPrams}`;

                    return React.createElement(DefaultCellV2, { navigateTo: link, value });
                },
                width: 300,
            },
            {
                header: "Pending Attendance",
                accessor: "pending_attendance",
                customRenderer: (value: any, item: any) => {
                    if (value == 0) return value
                    const fromDate = get(item, "from_date", "");
                    const toDate = get(item, "to_date", "");
                    const pa_id = get(item, "pa_id", "");
                    const queryPrams = `from=${moment(fromDate).format("YYYY-MM-DD")}&to=${moment(toDate).format("YYYY-MM-DD")}&pa_id=${pa_id}&type=attendance`;
                    const link = `/app/report/custom/student-enrolment-&-attendance-detailed-report?${queryPrams}`;

                    return React.createElement(DefaultCellV2, { navigateTo: link, value });
                },
                width: 300,
            },
            {
                header: "Pending Assessment Result",
                accessor: "pending_assessment_result",
                customRenderer: (value: any, item: any) => {
                    if (value == 0) return value
                    const fromDate = get(item, "from_date", "");
                    const toDate = get(item, "to_date", "");
                    const pa_id = get(item, "pa_id", "");
                    const queryPrams = `from=${moment(fromDate).format("YYYY-MM-DD")}&to=${moment(toDate).format("YYYY-MM-DD")}&pa_id=${pa_id}&type=assessment`;
                    const link = `/app/report/custom/student-enrolment-&-attendance-detailed-report?${queryPrams}`;
                    
                    return React.createElement(DefaultCellV2, { navigateTo: link, value });
                },
                width: 300,
            }
        ],
    },
    actions: [
        {
            text: "Print Report",
            onClick: async (filter: any, data: any, setLoading: any) => {
                if (filter.from && filter.to) {
                    setLoading(true);
                    try {
                        await printAction(PRINT.PRINT_STUDENT_ENROLMENT_AND_ATTENDANCE_REPORT, { filter }, setLoading);
                    } catch (error: any) {
                        setLoading(false);
                        const newError: any = new Error("Unable to print report");
                        newError.title = "Error";
                        newError.status = "error";
                        throw newError;
                    }
                } else {
                    const error: any = new Error(
                        "Please select the from date and to date"
                    );
                    error.title = "Warning";
                    error.status = "warning";
                    throw error;
                }
            },
            buttonVariant: "solid",
            buttonColorScheme: "teal",
        },
    ],
};

export default StudentEnrolAndAttSummaryConfig;